import { useEffect, useState } from "react";
import useClientSide from "@common/hooks/useClientSide";
import introJs from "intro.js";
import { IntroJs } from "intro.js/src/intro";
import { Options } from "intro.js/src/option";
import { IntroStep } from "intro.js/src/core/steps";
import { nextButtonLabel, skipButtonLabel } from "../helpers/htmlComponents";

type UseTourParams = {
  renderSteps: boolean;
  steps: Partial<IntroStep>[];
  options?: Options;
};

const useTour = ({ renderSteps, steps, options }: UseTourParams) => {
  const [tour, setTour] = useState<IntroJs>();
  const [inProgress, setInProgress] = useState<boolean>(false);

  const isClientSide = useClientSide();

  useEffect(() => {
    if (tour || !isClientSide) return;

    const tourInstance = introJs().onbeforeexit(() => {
      setInProgress(false);
      return true;
    });

    setTour(tourInstance);
  }, [isClientSide, options, renderSteps, steps, tour]);

  useEffect(() => {
    if (!tour) return;

    if (renderSteps) {
      tour.setOptions({
        hidePrev: true,
        tooltipClass: "rightride-tour",
        tooltipPosition: "top",
        nextLabel: nextButtonLabel,
        skipLabel: skipButtonLabel,
        disableInteraction: true,
        scrollTo: "tooltip",
        ...options,
        steps,
      });

      // Remove when https://github.com/usablica/intro.js/pull/2029 is merged
      /* eslint-disable @typescript-eslint/no-explicit-any */
      const { jQuery } = window as any;
      delete (window as any).jQuery;

      tour.start();

      // Restore jQuery so Gubagoo doesn't throw an error
      (window as any).jQuery = jQuery;
      /* eslint-enable @typescript-eslint/no-explicit-any */

      setInProgress(true);
    } else {
      tour.exit(false);
      setInProgress(false);
    }
  }, [options, renderSteps, steps, tour]);

  return { tour, inProgress };
};

export default useTour;
